var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#434343"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 18.6668H14M22.6667 13.3335V16.0002M17.3333 13.3335V16.0002M17.2 26.6668H22.8C23.9201 26.6668 24.4802 26.6668 24.908 26.4488C25.2843 26.2571 25.5903 25.9511 25.782 25.5748C26 25.147 26 24.5869 26 23.4668V17.8668C26 16.7467 26 16.1867 25.782 15.7588C25.5903 15.3825 25.2843 15.0766 24.908 14.8848C24.4802 14.6668 23.9201 14.6668 22.8 14.6668H17.2C16.0799 14.6668 15.5198 14.6668 15.092 14.8848C14.7157 15.0766 14.4097 15.3825 14.218 15.7588C14 16.1867 14 16.7467 14 17.8668V23.4668C14 24.5869 14 25.147 14.218 25.5748C14.4097 25.9511 14.7157 26.2571 15.092 26.4488C15.5198 26.6668 16.0799 26.6668 17.2 26.6668Z",
    stroke: "#2EC99E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCalendar);
export default __webpack_public_path__ + "static/media/green-calendar.13d58c193900091e035ddc65af5bfdae.svg";
export { ForwardRef as ReactComponent };